module.exports = __webpack_public_path__ + "img/rank-sec-thi.61780658.png";